import { LitElement, html } from 'lit';

import { api } from '../../api/index.js';
import { customerLoadState } from '../../components/customer-load-state.js';
import '../../components/customer-members.js';
import { poll } from '../../poll.js';
import { customerStyles } from '../../../styles/shared/customer.js';
import { pageStyles } from '../../../styles/shared/page.js';

/**
 * Who shares the workspaces of a customer user: the members of each of their customers. The owners
 * of a customer invite people with a link and manage the members; the others see who they are.
 * The memberships are read again on each poll: a role changed by an owner shows without signing in
 * again.
 */
class CustomerMembersPage extends LitElement {
  static styles = [pageStyles, customerStyles];

  constructor() {
    super();
    this.poll = poll(this, () => api.session());
  }

  render() {
    const head = html`
      <header class="page-head">
        <div>
          <h1>People</h1>
          <p class="lead">Who sees and changes your workspaces.</p>
        </div>
      </header>
    `;
    const pending = customerLoadState(this.poll);
    if (pending) {
      return html`${head}${pending}`;
    }
    const memberships = this.poll.value.memberships ?? [];
    if (memberships.length === 0) {
      return html`${head}<p class="empty">You do not belong to any customer yet.</p>`;
    }
    return html`
      ${head}
      ${memberships.map(
        (membership) => html`
          <section class="card">
            ${memberships.length > 1 ? html`<h2>${membership.name}</h2>` : null}
            ${membership.role === 'owner'
              ? html`<p class="muted">As an owner you invite people with a link, and change or remove members.</p>`
              : null}
            <plane-customer-members
              .customerId=${membership.id}
              .customerName=${membership.name}
              .canManage=${membership.role === 'owner'}
              @members-changed=${() => this.poll.refresh()}
            ></plane-customer-members>
          </section>
        `,
      )}
    `;
  }
}

customElements.define('plane-customer-members-page', CustomerMembersPage);
